export enum FilterType {
  EQUALS = "equals",
  NOT_EQUAL = "notEqual",
  LESS_THAN = "lessThan",
  GREATER_THAN = "greaterThan",
  IN_RANGE = "inRange",
}

export const FILTER_OPTIONS = [
  { value: FilterType.EQUALS, label: "Equals" },
  { value: FilterType.NOT_EQUAL, label: "Does not equal" },
  { value: FilterType.LESS_THAN, label: "Less than" },
  { value: FilterType.GREATER_THAN, label: "Greater Than" },
  { value: FilterType.IN_RANGE, label: "Between" },
];

export default {
  FilterType,
  FILTER_OPTIONS,
};
